import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";

const routes = [
    {
        path: "/:lang(tw|global)",
        name: "Home",
        component: Home,
        redirect: {
            name: "Index",
        },
        beforeEnter: async (to, from, next) => {
            await store.dispatch("fetchMenu", { lang: to.params.lang });
            next();
        },
        children: [
            {
                path: "index",
                name: "Index",
                component: () =>
                    import(
                        /* webpackChunkName: "content" */ "../views/subPage/index.vue"
                    ),
                //使用 beforeRouteEnter + beforeRouteUpdate
                meta: {
                    title: "CSR",
                },
            },
            {
                path: ":route",
                name: "Content",
                component: () =>
                    import(
                        /* webpackChunkName: "content" */ "../views/subPage/Content.vue"
                    ),
                //使用 beforeRouteEnter + beforeRouteUpdate
            },
            {
                path: "form",
                name: "FormPage",
                component: () =>
                    import(
                        /* webpackChunkName: "formPage" */ "../views/subPage/FormPage.vue"
                    ),
                //使用 beforeRouteEnter + beforeRouteUpdate
                meta: {
                    title: "CSR Form",
                },
            },
        ],
    },
    {
        path: "/csr/preview/:lang(tw|global)",
        name: "PreviewHome",
        component: Home,
        redirect: {
            name: "PreviewIndex",
        },
        beforeEnter: async (to, from, next) => {
            await store.dispatch("fetchMenu", { lang: to.params.lang });
            next();
        },
        children: [
            {
                path: "index",
                name: "PreviewIndex",
                component: () =>
                    import(
                        /* webpackChunkName: "content" */ "../views/subPage/index.vue"
                    ),
                // beforeEnter: async (to, from, next) => {
                //     // console.log("b");
                //     document.title = to.meta.title;
                //     await store.dispatch("fetchKv", {
                //         content: "index",
                //         lang: to.params.lang,
                //     });
                //     await store.dispatch("fetchContent", {
                //         content: "index",
                //         lang: to.params.lang,
                //     });
                //     next();
                // },
                meta: {
                    title: "CSR",
                },
            },
            {
                path: ":route",
                name: "PreviewContent",
                // alias: "/:route",
                component: () =>
                    import(
                        /* webpackChunkName: "content" */ "../views/subPage/Content.vue"
                    ),
                // beforeEnter: async (to, from, next) => {
                //     await store.dispatch("fetchKv", {
                //         content: to.params.route,
                //         lang: to.params.lang,
                //     });
                //     await store.dispatch("fetchContent", {
                //         content: to.params.route,
                //         lang: to.params.lang,
                //     });
                //     next();
                // },
            },
            {
                path: "form",
                name: "PreviewFormPage",
                component: () =>
                    import(
                        /* webpackChunkName: "content" */ "../views/subPage/FormPage.vue"
                    ),
                // beforeEnter: async (to, from, next) => {
                //     document.title = to.meta.title;
                //     await store.dispatch("fetchKv", {
                //         content: "form",
                //         lang: to.params.lang,
                //     });
                //     await store.dispatch("fetchCaptcha");
                //     next();
                // },
                meta: {
                    title: "CSR Form",
                },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0, behavior: "smooth" };
    },
});
router.beforeEach((to, from, next) => {
    store.dispatch("currentLang", to.params.lang);
    to.params.lang
        ? next()
        : next({ name: "Index", params: { lang: "global" } });
});

export default router;
